/**
 * @readonly
 * @enum {string}
 */
const TripModes = Object.freeze({
    BUSINESS: 'BUSINESS',
    PRIVATE: 'PRIVATE',
    COMMUTE: 'COMMUTE',
    CORRECTION: 'CORRECTION',
    WAYTOWORK: 'WAYTOWORK',
    UNKNOWN: 'UNKNOWN'
})

export { TripModes }
